import React from "react";
import { Button } from "antd";

function Logout(props) {
  return (
    <React.Fragment>
      <p>آیا مایل به خروج هستید؟</p>
      <div className="logout-buttons">
        <Button onClick={props.logout}>بله</Button>
        <Button onClick={props.close}>خیر</Button>
      </div>
    </React.Fragment>
  );
}

export default Logout;
